import classNames from 'classnames';
import { Field, Form as FormikForm, Formik } from 'formik';
import React, { useState } from 'react';
import Checkbox from '../form-elements/Checkbox';
import FormSection from '../form-elements/FormSection';
import Input from '../form-elements/Input';
import Notification from '../form-elements/Notification';
import Textarea from '../form-elements/Textarea';
import { ContactFormValidation, submitForm } from './contact.service';
const ContactForm = () => {
    const [success, setSuccess] = useState(null);
    const [error, setError] = useState(null);
    return (React.createElement(Formik, { initialValues: {
            firstName: '',
            lastName: '',
            email: '',
            phone: '',
            street: '',
            place: '',
            message: '',
            privacy: false,
        }, validationSchema: ContactFormValidation, onSubmit: async (values) => {
            setSuccess(null);
            setError(null);
            try {
                await submitForm(values);
                setSuccess(true);
            }
            catch (e) {
                setError(true);
            }
        } }, ({ isSubmitting }) => (React.createElement(FormikForm, null,
        React.createElement(React.Fragment, null,
            React.createElement(FormSection, { gridElementMaxWidth: '12.25rem' },
                React.createElement(Field, { as: Input, label: 'Vorname*', name: 'firstName', autoComplete: 'given-name' }),
                React.createElement(Field, { as: Input, label: 'Nachname*', name: 'lastName', autoComplete: 'family-name' })),
            React.createElement(FormSection, null,
                React.createElement(Field, { as: Input, label: 'E-Mail-Adresse*', name: 'email', autoComplete: 'email', type: 'email' }),
                React.createElement(Field, { as: Input, label: 'Telefonnumer*', name: 'phone', autoComplete: 'tel', type: 'tel' }),
                React.createElement(Field, { as: Input, label: 'Stra\u00DFe / Hausnummer', name: 'street', autoComplete: 'street-address' }),
                React.createElement(Field, { as: Input, label: 'PLZ / Ort', name: 'place', autoComplete: 'address-level2' }),
                React.createElement(Field, { as: Textarea, label: 'Ihre Nachricht*', name: 'message', rows: 4 })),
            React.createElement(FormSection, null,
                React.createElement(Field, { as: Checkbox, name: 'privacy' },
                    React.createElement("span", null,
                        "Informationen zur Verarbeitung Ihrer personenbezogenen Daten bei Nutzung des Kontaktformular finden Sie in unserer",
                        React.createElement("a", { href: '/datenschutz', target: '_blank', rel: 'noopener noreferrer' }, "Datenschutzerkl\u00E4rung"),
                        ' ',
                        "."))),
            !success && (React.createElement("div", { className: 'submit-btn-container' },
                React.createElement("button", { type: 'submit', className: classNames('btn is-secondary', { 'is-loading': isSubmitting }) }, "Absenden"))),
            success && React.createElement(Notification, { type: 'success' }, "Vielen Dank, wir haben Ihre Nachricht erhalten."),
            error && (React.createElement(Notification, { type: 'error' }, "Hier ist etwas schiefgelaufen, bitte versuchen Sie es erneut.")))))));
};
export default ContactForm;
